// If user has already accessed documents page in current session, redirect them there
if (sessionStorage.getItem("memberAccess")) {
    window.location.replace("documents.html");
}

const passwordInput = document.querySelector("#password");
const submitBtn = document.querySelector("#password-submit");
const errorMsg = document.querySelector("#password-error");

// If the error message is shown, remove it when user starts typing again
passwordInput.addEventListener("input", () => {
    if (!errorMsg.classList.contains("d-none")) {
        errorMsg.classList.add("d-none");
    }
});

submitBtn.addEventListener("click", (e) => {
    e.preventDefault();

    const password = passwordInput.value.trim().toLowerCase();

    if (password === "nsufbb@2026") {
        // If correct password is entered, store access in session and redirect to documents page
        sessionStorage.setItem("memberAccess", "true");
        window.location.replace("documents.html");
    } else {
        // If password is incorrect, show error message and clear input/add focus
        errorMsg.classList.remove("d-none");
        passwordInput.value = "";
        passwordInput.focus();
    }
});
